import "../../stylesheets/App.css";
import "../../stylesheets/Game.css";
import "../../stylesheets/GameMyScore.css";
import React, { useState, useEffect } from "react";

function GameMyScore(props) {
  let [orderedTeams, setOrderedTeams] = useState([]);
  let [background1, setBackground1] = useState({});
  let [background2, setBackground2] = useState({});

  useEffect(() => {
    const teams = props.data.teams || [];
    if (teams.length === 2) {
      const sorted = [...teams].sort(
        (a, b) => a.GameTeam.order - b.GameTeam.order
      );
      setOrderedTeams(sorted);
      setBackground1({ backgroundImage: "url(" + sorted[0].image_url + ")" });
      setBackground2({ backgroundImage: "url(" + sorted[1].image_url + ")" });
    }
  }, [props.data.teams]);

  const backgroundRed = { background: "var(--color-rojo)" };
  const backgroundGreen = { background: "var(--color-verde)" };

  // ✅ Partido terminado: cuando ya hay score cargado en ambos equipos
  const isFinished =
    orderedTeams[0]?.GameTeam?.score != null && orderedTeams[1]?.GameTeam?.score != null;

  // ✅ Resultado calculado por el back en tabla scores: TOTAL / PARCIAL / NADA
  const isTotal = props.score?.result === "TOTAL";

  // ✅ Si terminó, pintamos por result (no por coincidencia de número)
  const betStyle = isFinished && props.bet ? (isTotal ? backgroundGreen : backgroundRed) : {};

  return (
    <>
      <div className="game-container game-myscore-container">
        <div className="team-container team-left">
          <h4>{orderedTeams[0]?.name || ""}</h4>
          <div className="input-container">
            <input
              style={betStyle}
              type="text"
              className="score-imput"
              placeholder="-"
              value={props.bet ? props.bet.score1 : ""}
              disabled
            />
          </div>
          <p className="score-p">
            {props.bet ? "Pronóstico: " + props.bet.score1 + "-" + props.bet.score2 : ""}
          </p>
        </div>

        <div className="date-container">
          <p className="result-p">Resultado del partido</p>
          <h2 className="result-game">
            {isFinished
              ? orderedTeams[0].GameTeam.score + " : " + orderedTeams[1].GameTeam.score
              : ""}
          </h2>
        </div>

        <div className="team-container team-right">
          <h4>{orderedTeams[1]?.name || ""}</h4>
          <div className="input-container">
            <input
              style={betStyle}
              type="text"
              className="score-imput"
              placeholder="-"
              value={props.bet ? props.bet.score2 : ""}
              disabled
            />
          </div>
          <p className="score-p">{props.score ? "Puntos: " + props.score.score : ""}</p>
        </div>
      </div>
    </>
  );
}

export default GameMyScore;
